export default "__VITE_ASSET__4tPxeH9___"